import type { RisksByTierResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetRisksByTierQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRisksByTierDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetRisksByTierArgs = {
  tier: number;
  entityIds?: string[];
};

export const useGetRisksByTier = createQueryHook<
  UseGetRisksByTierArgs,
  RisksByTierResponseRow[],
  GetRisksByTierQuery
>({
  trpcQueryOptions: (trpc, { tier, entityIds }) =>
    trpc.frontend.risk.risksByTier.queryOptions({
      tier,
      entityIds: entityIds?.length ? entityIds : undefined,
    }),
  mapTrpcDataToGraphQL: (data) => ({ risk: data }),
  graphqlDocument: GetRisksByTierDocument,
  graphqlVariables: ({ tier, entityIds }) => {
    const where: Record<string, unknown> = { Tier: { _eq: tier } };
    if (entityIds?.length) {
      where['enterpriseRiskInstance'] = { EntityId: { _in: entityIds } };
    }

    return { where };
  },
});
